import { jwtDecode } from "jwt-decode";
import axios from "axios";

class TokenManager {
  static async storeTokens(accessToken, refreshToken) {
    try {
      // // console.log(`[WEB1] STORING TOKENS:`);
      // // console.log(`  - Access Token: ${accessToken.substring(0, 20)}...`);
      // // console.log(`  - Refresh Token: ${refreshToken.substring(0, 20)}...`);

      // Decode tokens to get expiry information
      const decodedAccessToken = jwtDecode(accessToken);
      const decodedRefreshToken = jwtDecode(refreshToken);

      // // console.log(`[WEB1] ACCESS TOKEN DETAILS:`);
      // // console.log(`  - Token Type: Access Token`);
      // // console.log(
      //   `  - Expiry: ${new Date(decodedAccessToken.exp * 1000).toISOString()}`
      // );
      // // console.log(`  - User ID: ${decodedAccessToken._id}`);

      // // console.log(`[WEB1] REFRESH TOKEN DETAILS:`);
      // // console.log(`  - Token Type: Refresh Token`);
      // // console.log(
      //   `  - Expiry: ${new Date(decodedRefreshToken.exp * 1000).toISOString()}`
      // );
      // // console.log(`  - User ID: ${decodedRefreshToken._id}`);

      localStorage.setItem("loginDetails", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      // // console.log(`[WEB1] Tokens stored successfully`);
    } catch (error) {
      console.error("[WEB1] Error storing tokens", error);
    }
  }

  static getAccessToken() {
    try {
      const token = localStorage.getItem("loginDetails");
      // // console.log(
      //   `[WEB1] Retrieved access token: ${
      //     token ? token.substring(0, 20) + "..." : "null"
      //   }`
      // );
      return token;
    } catch (error) {
      console.error("[WEB1] Error retrieving access token", error);
      return null;
    }
  }

  static getRefreshToken() {
    try {
      const token = localStorage.getItem("refreshToken");
      // // console.log(
      //   `[WEB1] Retrieved refresh token: ${
      //     token ? token.substring(0, 20) + "..." : "null"
      //   }`
      // );
      return token;
    } catch (error) {
      console.error("[WEB1] Error retrieving refresh token", error);
      return null;
    }
  }

  static clearAllTokens() {
    try {
      // // console.log(`[WEB1] CLEARING ALL TOKENS`);
      localStorage.removeItem("loginDetails");
      localStorage.removeItem("refreshToken");
      // // console.log(`[WEB1] All tokens cleared successfully`);
    } catch (error) {
      // console.error("[WEB1] Error clearing tokens", error);
    }
  }

  static isTokenExpired(token) {
    if (!token) {
      // console.log(`[WEB1] TOKEN EXPIRY CHECK: No token provided`);
      return true;
    }

    try {
      const decoded = jwtDecode(token);
      if (!decoded || !decoded.exp) {
        // console.log(`[WEB1] TOKEN EXPIRY CHECK: Invalid token structure`);
        return true;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      const isExpired = decoded.exp < currentTime;

      // console.log(`[WEB1] TOKEN EXPIRY CHECK:`);
      // console.log(
      //   `  - Current Time: ${new Date(currentTime * 1000).toISOString()}`
      // );
      // // console.log(
      //   `  - Token Expiry: ${new Date(decoded.exp * 1000).toISOString()}`
      // );
      // // console.log(`  - Is Expired: ${isExpired}`);

      return isExpired;
    } catch (error) {
      console.error("[WEB1] Error decoding token:", error);
      return true;
    }
  }

  static isRefreshTokenExpired(token) {
    if (!token) {
      // console.log(`[WEB1] REFRESH TOKEN EXPIRY CHECK: No token provided`);
      return true;
    }

    try {
      const decoded = jwtDecode(token);
      if (!decoded || !decoded.exp) {
        // console.log(
        //   `[WEB1] REFRESH TOKEN EXPIRY CHECK: Invalid token structure`
        // );
        return true;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      const isExpired = decoded.exp < currentTime;

      // console.log(`[WEB1] REFRESH TOKEN EXPIRY CHECK:`);
      // console.log(
      //   `  - Current Time: ${new Date(currentTime * 1000).toISOString()}`
      // );
      // // console.log(
      //   `  - Token Expiry: ${new Date(decoded.exp * 1000).toISOString()}`
      // );
      // // console.log(`  - Is Expired: ${isExpired}`);

      return isExpired;
    } catch (error) {
      console.error("[WEB1] Error decoding refresh token:", error);
      return true;
    }
  }

  static willTokenExpireWithin24Hours(token) {
    if (!token) {
      // console.log(`[WEB1] 24H EXPIRY CHECK: No token provided`);
      return true;
    }

    try {
      const decoded = jwtDecode(token);
      if (!decoded || !decoded.exp) {
        // console.log(`[WEB1] 24H EXPIRY CHECK: Invalid token structure`);
        return true;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      const twentyFourHoursInSeconds = 24 * 60 * 60; // 24 hours in seconds
      const willExpire = decoded.exp < currentTime + twentyFourHoursInSeconds;

      // // console.log(`[WEB1] 24H EXPIRY CHECK:`);
      // // console.log(
      //   `  - Current Time: ${new Date(currentTime * 1000).toISOString()}`
      // );
      // // console.log(
      //   `  - Token Expiry: ${new Date(decoded.exp * 1000).toISOString()}`
      // );
      // // console.log(
      //   `  - 24H From Now: ${new Date(
      //     (currentTime + twentyFourHoursInSeconds) * 1000
      //   ).toISOString()}`
      // );
      // console.log(`  - Will Expire Within 24H: ${willExpire}`);

      return willExpire;
    } catch (error) {
      console.error("[WEB1] Error decoding token:", error);
      return true;
    }
  }

  static async refreshTokens(retryCount = 0) {
    try {
      // console.log(`[WEB1] REFRESH TOKENS ATTEMPT #${retryCount + 1}`);

      const refreshToken = this.getRefreshToken();

      if (!refreshToken) {
        // console.log(
        //   "[WEB1] No refresh token available - user needs to login again"
        // );
        return false;
      }

      // console.log(`[WEB1] Making refresh token request to backend`);

      const response = await axios.post(
        `https://api.storytent.in/api/user/refresh-token`,
        { refreshToken }
      );

      if (response.data.status === "Success") {
        const { token: newAccessToken, refreshToken: newRefreshToken } =
          response.data.data;

        // console.log(`[WEB1] REFRESH TOKENS SUCCESS:`);
        // console.log(
        //   `  - New Access Token: ${newAccessToken.substring(0, 20)}...`
        // );
        // // console.log(
        //   `  - New Refresh Token: ${newRefreshToken.substring(0, 20)}...`
        // );

        this.storeTokens(newAccessToken, newRefreshToken);
        return true;
      } else {
        throw new Error("Token refresh failed");
      }
    } catch (error) {
      console.error(
        `[WEB1] Token refresh error (attempt ${retryCount + 1}):`,
        error
      );

      if (retryCount < 2) {
        const delay = 1000 * (retryCount + 1);
        // console.log(`[WEB1] Retrying in ${delay}ms...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return await this.refreshTokens(retryCount + 1);
      }

      return false;
    }
  }

  static async checkAndRefreshToken() {
    try {
      // console.log(`[WEB1] CHECKING AND REFRESHING TOKEN`);

      const accessToken = this.getAccessToken();

      if (!accessToken) {
        // console.log(`[WEB1] No access token found`);
        return false;
      }

      // Check if access token is expired
      if (this.isTokenExpired(accessToken)) {
        // console.log(`[WEB1] Access token is expired, attempting refresh`);

        const refreshToken = this.getRefreshToken();
        if (!refreshToken) {
          // console.log(
          //   `[WEB1] No refresh token available for expired access token`
          // );
          this.handleLogout("Session expired");
          return false;
        }

        if (this.isRefreshTokenExpired(refreshToken)) {
          // console.log(`[WEB1] Both access and refresh tokens are expired`);
          this.handleLogout("Session expired");
          return false;
        }

        const refreshed = await this.refreshTokens();
        if (!refreshed) {
          // console.log(`[WEB1] Token refresh failed`);
          this.handleLogout("Session expired");
          return false;
        }

        // console.log(`[WEB1] Token refresh successful`);
        return true;
      }

      // Check if access token will expire within 24 hours
      if (this.willTokenExpireWithin24Hours(accessToken)) {
        // console.log(
        //   `[WEB1] Access token will expire within 24 hours, proactive refresh`
        // );

        const refreshToken = this.getRefreshToken();
        if (!refreshToken) {
          // // console.log(
          //   `[WEB1] No refresh token available for proactive refresh`
          // );
          return true; // Continue with current token
        }

        if (this.isRefreshTokenExpired(refreshToken)) {
          // console.log(
          //   `[WEB1] Refresh token is expired during proactive refresh`
          // );
          this.handleLogout("Session expired");
          return false;
        }

        const refreshed = await this.refreshTokens();
        if (!refreshed) {
          // console.log(
          //   `[WEB1] Proactive token refresh failed, continuing with current token`
          // );
          return true; // Continue with current token
        }

        // console.log(`[WEB1] Proactive token refresh successful`);
        return true;
      }

      // console.log(`[WEB1] Token is valid and not expiring soon`);
      return true;
    } catch (error) {
      console.error("[WEB1] Error checking/refreshing token:", error);
      this.handleLogout("Session expired");
      return false;
    }
  }

  static handleLogout(message = "Session expired") {
    try {
      // console.log(`[WEB1] HANDLING LOGOUT: ${message}`);
      this.clearAllTokens();

      window.alert(message);
      // console.log(`[WEB1] Navigating to login screen`);
      window.location.href = "/login";
    } catch (error) {
      console.error("[WEB1] Error during logout:", error);
      window.location.href = "/login";
    }
  }

  // Helper function to get token for API calls
  static getTokenForAPI() {
    try {
      const accessToken = this.getAccessToken();
      if (accessToken) {
        // console.log(`[WEB1] API CALL: Using access token from loginDetails`);
        return accessToken;
      }

      // console.log(`[WEB1] API CALL: No token found`);
      return null;
    } catch (error) {
      console.error("[WEB1] Error getting token for API:", error);
      return null;
    }
  }
}

export default TokenManager;
